var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75C5.4 6.75 6.75 5.4 6.75 3.75C6.75 2.1 5.4 0.75 3.75 0.75C2.1 0.75 0.75 2.1 0.75 3.75C0.75 5.4 2.1 6.75 3.75 6.75ZM3.75 0C5.8125 0 7.5 1.6875 7.5 3.75C7.5 5.8125 5.8125 7.5 3.75 7.5C1.6875 7.5 0 5.8125 0 3.75C0 1.6875 1.6875 0 3.75 0ZM3.9375 4.05L2.1375 5.1L1.875 4.575L3.375 3.7125V1.875H3.9375V4.05Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock2.52a9b1fc.svg";
export { ForwardRef as ReactComponent };